import React from "react";
import { Route, RouteProps, Redirect } from "react-router-dom";
import { LoginService } from "../Services/LoginService";
import { AnyObject } from "types";

type PrivateRouteProps = Omit<RouteProps, "component"> & {
  component: React.ComponentType<AnyObject>;
};

const PrivateRoute = ({
  component,
  ...rest
}: PrivateRouteProps): JSX.Element => {
  const routeComponent = (props: AnyObject) =>
    LoginService.isAuthenticated() ? (
      React.createElement(component, props)
    ) : (
      <Redirect to="/login" />
    );
  return <Route {...rest} render={routeComponent} />;
};

export default PrivateRoute;
